/*
 * What acts on a click around something that opens on a tap (a Toggletip's trigger, a person's
 * name): a row, or a control. Each decides whether the tap is its own or its host's.
 */

/** What acts on a click around a trigger: a row, a control, or nothing. */
export type ClickHost = "none" | "row" | "control"

/**
 * An ancestor that acts on a click: a link, or an element marked `data-pressable` because its
 * handler does (a GroupHeader folds). A button is a control, and so is a list's option or a menu's
 * item, which chooses on a click (an assignee Picker's option, its avatar inside it).
 */
const rows = "a[href], [data-pressable]"
const controls =
  "button, [role=button], [role=option], [role=menuitem], [role=menuitemradio], [role=menuitemcheckbox]"

export function clickHostOf(trigger: HTMLElement): ClickHost {
  const around = trigger.parentElement
  if (around?.closest(controls)) return "control"
  if (around?.closest(rows)) return "row"
  return "none"
}
